import { render, staticRenderFns } from "./FindingItemImagesGroup.vue?vue&type=template&id=6b062206&"
import script from "./FindingItemImagesGroup.vue?vue&type=script&lang=js&"
export * from "./FindingItemImagesGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports